export class UniqueIdentifierFactory {
    /** @description Creates a new random number
     */
    Create(): number {
        return Math.round(Math.random() * 1000000)
    }
}

export default new UniqueIdentifierFactory();
